

import React from 'react';
import { Link } from 'react-router-dom';
import {
    FaFacebook,
    FaTwitter,
    FaInstagram,
    FaSnapchat,
    FaPinterest,
} from 'react-icons/fa';
import { ReactComponent as TikTokIcon } from '../assets/tik-tok.svg';


export interface BaseFooterProps { }

const BaseFooter: React.FC<BaseFooterProps> = () => {
    return (
        <>
            <footer className="ft-bg">
                <div className="container">
                    <div className="row ft-padding clearfix">
                        <div className="col-sm-3">
                            <div className="footer-left">
                                <a href="#">
                                    <img
                                        alt="twigbig"
                                        width="137px"
                                        src={`${process.env.PUBLIC_URL}/assets/img/twigLogoWhite.svg`}
                                    />
                                </a>
                                <ul>
                                    <li>
                                        <Link to="contact-us">Contact Us</Link>
                                    </li>
                                    <li style={{ marginBottom: '5px' }}>
                                        <a style={{ fontSize: '11px' }}>WE ACCEPT</a>
                                    </li>
                                    <li style={{ marginBottom: '0' }}>
                                        <img
                                            style={{
                                                width: '76px',
                                                height: '44px',
                                                marginRight: '5px',
                                                borderRadius: '8%',
                                                backgroundColor: "white",
                                                objectFit: "contain"
                                            }}
                                            src="images/MasterCard.jpg"
                                            alt="twigbig"
                                        />
                                        <img
                                            style={{
                                                width: '76px',
                                                height: '44px',
                                                borderRadius: '8%',
                                                backgroundColor: "white",
                                                objectFit: "contain"
                                            }}
                                            src="images/visa.PNG"
                                            alt="twigbig"
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-sm-5">
                            <div className="footer-middle">
                                <h5>FOLLOW US</h5>
                                <ul>
                                    <li>
                                        <a href="https://www.facebook.com/twigbig/">
                                            <FaFacebook />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/twigBIGTweets">
                                            <FaTwitter />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/twigbig/">
                                            <FaInstagram />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.snapchat.com/add/twigbigsnap">
                                            <FaSnapchat />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.pinterest.com/twigbig/">
                                            <FaPinterest />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.tiktok.com/@twigbig">
                                            <TikTokIcon />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="footer-middle footer-right pull-right">
                                <h5>DOWNLOAD THE APP</h5>
                                <ul>
                                    <li>
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="https://itunes.apple.com/us/app/twigbig/id1222335980?ls=1&mt=8"
                                        >
                                            <img src="img/ft-1.png" alt="itunes apple" />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="https://play.google.com/store/apps/details?id=com.twigbig.app"
                                        >
                                            <img src="img/ft-2.png" alt="play google" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="copyrights clearfix">
                        <div className="copy-right pull-right">
                            <ul style={{ width: '300px', marginBottom: '20px' }}>
                                <li style={{ width: '100%' }}>
                                    <Link to="terms-and-conditions">
                                        Terms & Conditions{' '}
                                    </Link>
                                </li>
                                <li style={{ width: '100%' }}>
                                    <Link to="privacy-policy">
                                        Privacy Policy
                                    </Link>
                                </li>
                                <li style={{ width: '100%' }}>
                                    <Link to="refund-and-cancellation-policy">
                                        Refund and Cancellation policy
                                    </Link>
                                </li>
                                <li style={{ width: '100%' }}>
                                    <Link to="shipping-and-return-policy">
                                        Shipping and Return Policy
                                    </Link>
                                </li>

                                <li style={{ width: '100%' }}>
                                    <Link to="about-us">
                                        About Us
                                    </Link>
                                </li>


                                <li style={{ width: '100%', display: "none" }}>
                                    <Link to="discover">
                                        Discover
                                    </Link>
                                </li>


                            </ul>
                        </div>
                    </div>
                    <div className="copy-left pull-left">
                        <h5> © 2021 twigBIG, Inc. All Rights Reserved.</h5>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default BaseFooter
